<div class="container-fluid g-0 m-0">
  <div class="d-flex g-0 m-0">
    <div class="sidemenu-nav background-color">
      <h6 class="sidemenu-title">
        {{ "SCHEDULEDDATAREAD" | translate | uppercase }}
      </h6>
      @if(authService.isAuthorized([PermissionsEnum.Scheduled_loadprofile_view])){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('scheduled/load-profile')"
          [ngClass]="{ selected: isActive('scheduled/load-profile') }"
        >
          <span>{{ "LOAD_PROFILE_DATA" | translate }}</span>
        </div>
      }
      @if(authService.isAuthorized([PermissionsEnum.Scheduled_energyregister_view])){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('scheduled/energy')"
          [ngClass]="{ selected: isActive('scheduled/energy') }"
        >
          <span>{{ "ENERGY_REGISTER_DATA" | translate }}</span>
        </div>
      }
      @if(authService.isAuthorized([PermissionsEnum.Scheduled_powerdemandregister_view])){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('scheduled/power-demand')"
          [ngClass]="{ selected: isActive('scheduled/power-demand') }"
        >
          <span>{{ "POWER_DEMAND_DATA" | translate }}</span>
        </div>
      }
      @if(authService.isAuthorized([PermissionsEnum.Scheduled_instantaneousobject_view])){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('scheduled/instantaneous-object')"
          [ngClass]="{
            selected: isActive('scheduled/instantaneous-object'),
          }"
        >
          <span>{{ "INSTANTANEOUS_OBJECT_DATA" | translate }}</span>
        </div>
      }
      @if(authService.isAuthorized([PermissionsEnum.Scheduled_event_log_view])){
        <div
          class="sidemenu-item-font item"
          (click)="navigate('scheduled/event-logs')"
          [ngClass]="{ selected: isActive('scheduled/event-logs') }"
        >
          <span>{{ "EVENT_LOG_DATA" | translate }}</span>
        </div>
      }
    </div>
    <div class="sidemenu-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
